import sidebarFooter from './components/sidebar-footer/sidebar-footer.angular';
export default angular.module('doxy.sidebar', [sidebarFooter]).name;
